import { render, staticRenderFns } from "./ChartRouter.vue?vue&type=template&id=1aa9e6d4&"
import script from "./ChartRouter.vue?vue&type=script&lang=js&"
export * from "./ChartRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardTitle,VIcon,VListItemContent})
